import { DefaultBadgeBackground, DefaultBadgeCore } from '@levelSystem/components/badges';
import { BadgeProps } from '@levelSystem/types';
import clsx from 'clsx';

type Props = BadgeProps & {
    badgeBackgroundProps?: Omit<BadgeProps, 'level'>;
    badgeCoreProps?: Omit<BadgeProps, 'level'>;
};

const DefaultBadge = ({ className, level, badgeBackgroundProps, badgeCoreProps }: Props) => {
    return (
        <div className={clsx('size-8 relative', className)}>
            <DefaultBadgeBackground level={level} {...badgeBackgroundProps} />
            <DefaultBadgeCore level={level} {...badgeCoreProps} />
        </div>
    );
};

export { DefaultBadge };
